import { LIST_RADIUS_SEARCH_OPTIONS } from 'stacks/Nearby/NearbyRadiusDropdown';

export type RadiusFilterOption = (typeof LIST_RADIUS_SEARCH_OPTIONS)[number];

export type RadiusFilterState = {
  currentRadius: RadiusFilterOption;
};

export const DEFAULT_RADIUS_FILTER_VALUE = LIST_RADIUS_SEARCH_OPTIONS[1];
